(() => {
  const home = document.querySelector('[data-odk-home]');
  if (!home || home.dataset.ready) return;
  home.dataset.ready = 'true';

  const progress = home.querySelector('.odk-progress span');
  const updateProgress = () => {
    const rect = home.getBoundingClientRect();
    const total = Math.max(home.offsetHeight - window.innerHeight, 1);
    const passed = Math.min(Math.max(-rect.top, 0), total);
    progress.style.transform = `scaleX(${passed / total})`;
  };
  addEventListener('scroll', updateProgress, { passive: true });
  updateProgress();

  home.querySelectorAll('.odk-reveal').forEach((el) => el.classList.add('is-visible'));

  if (matchMedia('(pointer:fine)').matches) {
    home.querySelectorAll('[data-tilt]').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const r = card.getBoundingClientRect();
        const x = (event.clientX - r.left) / r.width - .5;
        const y = (event.clientY - r.top) / r.height - .5;
        card.style.setProperty('--rx', `${y * -4}deg`);
        card.style.setProperty('--ry', `${x * 5}deg`);
        card.style.setProperty('--mx', `${(x + .5) * 100}%`);
        card.style.setProperty('--my', `${(y + .5) * 100}%`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  }
})();
